import { useMutation } from '@tanstack/react-query'
import { integrationOptionValues } from '../../v3/integrationOptionValues'
import { type IntegrationOptionValue } from './types'

/**
 * Invalidate `globalQueryKeys.integrationOptionValues` in the call site's
 * `onSuccess`.
 */
export function useDeleteIntegrationOptionValue() {
  return useMutation({
    mutationFn: (id: IntegrationOptionValue['id']) =>
      integrationOptionValues.delete({
        params: { path: { integration_option_value_id: id } },
      }),
  })
}
